export const CITY_STORAGE_KEY = 'hebrew-hearts-preferred-city';
export const REF_STORAGE_KEY = 'hebrew-hearts-ref';

export function readPreferredCity() {
  try {
    return window.localStorage.getItem(CITY_STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function sanitizeReferralCode(value) {
  return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 12);
}

export function readStoredReferralCode() {
  try {
    return sanitizeReferralCode(window.localStorage.getItem(REF_STORAGE_KEY) || '');
  } catch {
    return '';
  }
}

export function storeReferralCode(value) {
  const code = sanitizeReferralCode(value);
  if (!code) return;
  try {
    window.localStorage.setItem(REF_STORAGE_KEY, code);
  } catch {
    // Storage unavailable (private mode); the code is simply not persisted.
  }
}

export async function fetchLaunchAccess(citySlug = readPreferredCity()) {
  const query = citySlug ? `?city=${encodeURIComponent(citySlug)}` : '';
  const response = await fetch(`/api/launch-status${query}`, {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Launch status is unavailable');

  const payload = await response.json();
  const selectedMarket = payload?.selectedMarket
    || (payload?.markets || []).find((market) => market.slug === citySlug)
    || null;

  return {
    selectedMarket,
    canSignUp: selectedMarket?.status === 'launched',
  };
}
